import "bootstrap/dist/css/bootstrap.css";
import "@/assets/main.scss";
import "bootstrap/dist/js/bootstrap.js";
import "@/assets/main.scss";
//import "bootstrap/dist/js/bootstrap.js";
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from "./App.vue";
import PoliticaDePrivacidade from "../privacy-policy/App.vue";
import TermosDeUso from "../terms-of-use/App.vue";

const routes = [
  { path: '/', component: App },
  { path: '/privacy-policy', component: PoliticaDePrivacidade },
  { path: '/terms-of-use', component: TermosDeUso },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const app = createApp(App)

app.use(router)

app.mount('#app') 
//createApp(App).mount('#app')